// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.school-choice-page .dark-blue-text {
  color: #19608f;
}
.school-choice-page .hr-page {
  margin: 10px auto;
  width: 90%;
}
.school-choice-page .employee-id-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.school-choice-page .employee-id-container .employee-id-button {
  margin: 30px 20px 0 0;
  min-width: 270px;
}

.employee-id-form {
  margin-top: 24px;
}
.employee-id-form input[type=text] {
  border-radius: 5px;
  border: 1px solid #A7A9AC;
  display: block;
  padding: 4px;
}
.employee-id-form label {
  display: block;
}
.employee-id-form p {
  color: #333;
  font-size: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SchoolChoice.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANI;EACI,cDGE;ACMV;AANI;EACI,iBAAA;EACA,UAAA;AAQR;AANI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;AAQR;AAPQ;EACI,qBAAA;EACA,gBAAA;AASZ;;AAJA;EACI,gBAAA;AAOJ;AALI;ECzBA,kBD0B0B;EACtB,yBAAA;EACA,cAAA;EACA,YAAA;AAOR;AALI;EACI,cAAA;AAOR;AALI;EACI,WAAA;EACA,iBAAA;AAOR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.school-choice-page {\n    .dark-blue-text {\n        color: $dk-blue;\n    }\n\n    .hr-page {\n        margin: 10px auto;\n        width: 90%;\n    }\n    .employee-id-container {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        width: 100%;\n        .employee-id-button {\n            margin: 30px 20px 0 0;\n            min-width: 270px;\n        }\n    }\n}\n\n.employee-id-form {\n    margin-top: 24px;\n\n    input[type=\"text\"] {\n        @include borderRadius(5px);\n        border: 1px solid $grey2;\n        display: block;\n        padding: 4px;\n    }\n    label {\n        display: block;\n    }\n    p {\n        color: #333;\n        font-size: 0.8rem;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
